import type { IDB, IDBOptions } from './interface';
import IndexedDB from './idb.db';

const DEFAULT_DB_NAME = 'ApiService-DB';

const DEFAULT_OPTIONS: IDBOptions = {
    version: 1,
    engine: 'indexeddb',
    mappings: {},
};

function open(name: string = DEFAULT_DB_NAME, optionsIn: Partial<IDBOptions> = {}): IDB {
    const options = {
        ...DEFAULT_OPTIONS,
        ...optionsIn,
        name,
    };

    return IndexedDB(name, options);
}

export default open;
